module.exports = {
  draftsList: 'List of Deactivations',
  closedList: 'Closed List',
  editImage: {
    title: 'Edit Image',
  },
  header: {
    title: 'Partners',
    buttonCreate: 'Add partner',
    buttonPublish: 'Publish',
  },
  table: {
    title: {
      index: 'NO',
      title: 'NAME',
      logo: 'BRAND LOGO',
      action: 'ACTION',
    },
    tooltip: {
      edit: 'Edit',
      delete: 'Delete',
    },
    popup: {
      title: 'Confirm',
      titleErr: 'Unable to delete partner',
      okBtn: 'Yes',
      okDone: 'Done',
      cancelBtn: 'No',
      delete: 'Are you sure to delete this Partner?',
      edit: 'Are you sure to edit this Partner?',
    },
  },
  form: {
    image3x4: 'Choose an image or drag it here',
    title: 'Name',
    btnUpdatePartner: 'Update',
    btnCreatePartner: 'Add',
    updatePartner: 'Edit Partner',
    createPartner: 'Add Partner',
  },
  validate: {
    titleBlank: 'Please input name!',
    imageBlank: 'Please upload a brand logo!',
  },
  message: {
    error: {
      uploadImage: 'There was an error while uploading the image. Please try again',
      requireUpload: 'Please upload a brand logo!',
    },
    success: {
      updatePartner: 'Partner successfully updated.',
      createPartner: 'Partner successfully added.',
      deletePartner: 'Partner successfully deleted.',
    },
  },
};
